import React from "react";
import { useTranslation } from "react-i18next";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";

interface InvoiceTotalAmountsProps {
  totalAmountWithoutTax: number;
  totalTax: number;
  totalAmount: number;
  isConsolidatedInvoice?: boolean;
}

const InvoiceTotalAmounts: React.FC<InvoiceTotalAmountsProps> = ({
  totalAmountWithoutTax,
  totalTax,
  totalAmount,
  isConsolidatedInvoice,
}) => {
  const fieldWidth = isConsolidatedInvoice ? "w-74" : "w-80";
  const { t } = useTranslation(["common", "registration", "invoice"]);
  return (
    <>
      <div className="invoice-header__details__info__row d-flex justify-content-between px-2 total">
        <div
          className={`invoice-header__details__info__row__item ${fieldWidth}`}
        >
          <h6> {t("invoiceDetails.totalAmountWithoutTax")}</h6>
        </div>
        <VerticalDivider />
        <div className="invoice-header__details__info__row__item text-center w-25">
          <span>{totalAmountWithoutTax}</span>
        </div>
      </div>
      <HorizontalDivider />
      <div className="invoice-header__details__info__row d-flex justify-content-between px-2 total">
        <div
          className={`invoice-header__details__info__row__item ${fieldWidth}`}
        >
          <h6> {t("invoiceDetails.totalTax")}</h6>
        </div>
        <VerticalDivider />

        <div className="invoice-header__details__info__row__item text-center w-25">
          <span>{totalTax}</span>
        </div>
      </div>
      <HorizontalDivider />
      <div className="invoice-header__details__info__row d-flex justify-content-between px-2 total">
        <div
          className={`invoice-header__details__info__row__item ${fieldWidth}`}
        >
          <h6> {t("invoiceDetails.totalAmountWithTax")}</h6>
        </div>
        <VerticalDivider />
        <div className="invoice-header__details__info__row__item text-center w-25">
          <span>{totalAmount}</span>
        </div>
      </div>
    </>
  );
};

export default InvoiceTotalAmounts;
